import { render } from "./MyShiftPermissionsList.vue?vue&type=template&id=e870a61e&scoped=true"
import script from "./MyShiftPermissionsList.vue?vue&type=script&lang=js"
export * from "./MyShiftPermissionsList.vue?vue&type=script&lang=js"

import "./MyShiftPermissionsList.vue?vue&type=style&index=0&id=e870a61e&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e870a61e"]])

export default __exports__